/* ELTERNSTIMME™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović · Korrekturen integriert
 * Stand: 16 Folien (komplett) */
export const elternstimmeSlides = [
  {
    num: 1,
    type: "cover",
    title: "ELTERNSTIMME™",
    headline: [
      { t: "STARKE ELTERN.", c: "gold" },
      { t: "STARKE KINDER.", c: "rainbow" },
      { t: "STARKE ZUKUNFT.", c: "navy" },
    ],
    quote:
      "Die Familie ist der erste Ort, an dem Kinder lernen, zu lieben, zu vertrauen und an sich zu glauben.",
    intro: [
      "Elternschaft ist die schönste und gleichzeitig herausforderndste Aufgabe unseres Lebens.",
      { html: "Die <strong>ELTERNSTIMME™</strong> stärkt <em>Mütter</em> und <em>Väter</em>, unterstützt Familien und <em>schützt</em> Kinder." },
      "Gemeinsam gestalten wir eine Welt, in der Liebe, Respekt und Vertrauen die Grundlage für jede Zukunft sind.",
    ],
    pillars: [
      { h: "FAMILIE STÄRKEN", icon: "users", color: "#3D6BBF" },
      { h: "KOMMUNIKATION VERBESSERN", icon: "speech", color: "#7A85C4" },
      { h: "KINDER SCHÜTZEN", icon: "shield", color: "#D4AF37" },
      { h: "KONFLIKTE REDUZIEREN", icon: "balance", color: "#E89B5A" },
      { h: "ZUKUNFT GESTALTEN", icon: "globe", color: "#5A9B7E" },
    ],
    mission:
      "UNSERE MISSION: WIR HELFEN ELTERN, IHRE KRAFT ZU ENTFALTEN, DAMIT KINDER IN LIEBE AUFWACHSEN UND EINE BESSERE WELT GESTALTEN.",
    tagline: "HERZ · VERSTAND · SEELE · KRAFT · ALLE",
  },

  {
    num: 2,
    type: "content",
    kicker: "ELTERNSTIMME™",
    title: "WARUM ELTERNSTIMME?",
    quote:
      "Eltern zu sein ist die wichtigste Aufgabe unseres Lebens. Gemeinsam können wir sie besser meistern — für unsere Kinder und für unsere Welt.",
    intro: [
      "Kinder brauchen heute mehr denn je Eltern, die verbunden, präsent und handlungsfähig sind.",
      "Doch Stress, Konflikte, Zeitmangel und unterschiedliche Erziehungsvorstellungen stellen Familien vor grosse Herausforderungen.",
      { html: "<strong>ELTERNSTIMME™</strong> ist unsere Antwort — für Familien, die gemeinsam <em>wachsen</em>, <em>lernen</em> und eine <em>bessere Zukunft</em> schaffen wollen." },
    ],
    cardsTitle: "WARUM WIR ELTERN UNTERSTÜTZEN:",
    cards: [
      { h: "KONFLIKTE VERLETZEN", t: "Streit und Missverständnisse belasten Beziehungen und schwächen Kinder.", color: "#3D6BBF", icon: "lightning" },
      { h: "ZEIT FEHLT", t: "Viele Eltern fühlen sich zwischen Beruf, Alltag und Familie zerrissen.", color: "#5A9B7E", icon: "clock" },
      { h: "KINDER LEIDEN", t: "Kinder spüren Spannungen und Unsicherheiten — und brauchen Orientierung und Sicherheit.", color: "#E89B5A", icon: "heart" },
      { h: "UNTERSCHIEDE TRENNEN", t: "Verschiedene Werte und Erwartungen führen oft zu Distanz statt Zusammenhalt.", color: "#7A85C4", icon: "puzzle" },
      { h: "FAMILIEN BRAUCHEN UNTERSTÜTZUNG", t: "Eltern müssen nicht alles allein schaffen. Hilfe, Wissen und Austausch machen stark.", color: "#C77B7B", icon: "home" },
      { h: "ZUKUNFT BEGINNT ZU HAUSE", t: "Was wir heute als Eltern tun, bestimmt die Welt, in der unsere Kinder morgen leben.", color: "#5A9B9B", icon: "globe" },
    ],
    bottomBanner:
      "ELTERNSTIMME™ VERBINDET, STÄRKT UND BEGLEITET ELTERN DABEI, FAMILIEN IN LIEBE, RESPEKT UND VERTRAUEN ZU GESTALTEN.",
  },

  {
    num: 3,
    type: "content",
    kicker: "ELTERNSTIMME™",
    title: "DIE BEDEUTUNG VON ELTERNSCHAFT",
    quote:
      "Kinder erinnern sich nicht an das, was wir sagen. Sie erinnern sich an das, was wir sind und wie wir bei ihnen sind.",
    intro: [
      "Elternschaft ist mehr als eine Rolle — sie ist eine lebenslange Verantwortung und das grösste Geschenk zugleich.",
      "Eltern sind die ersten Lehrer, Vorbilder und Begleiter ihrer Kinder. Sie prägen Werte, Charakter und die Sicht auf die Welt.",
      "Was wir unseren Kindern heute mitgeben, bestimmt die Welt von morgen.",
    ],
    motto: "STARKE ELTERN SCHAFFEN STABILE KINDER. STABILE KINDER GESTALTEN EINE BESSERE WELT.",
    cardsTitle: "WAS ELTERN IHREN KINDERN SCHENKEN:",
    cards: [
      { h: "LIEBE & GEBORGENHEIT", t: "Kinder brauchen Liebe, um zu fühlen, dass sie wertvoll und gewollt sind.", color: "#3D6BBF", icon: "heart" },
      { h: "SICHERHEIT & VERTRAUEN", t: "Ein stabiles Umfeld gibt Kindern Halt und lässt sie mutig die Welt entdecken.", color: "#5A9B7E", icon: "shield" },
      { h: "WERTE & ORIENTIERUNG", t: "Werte wie Respekt, Ehrlichkeit und Mitgefühl sind ihr innerer Kompass fürs Leben.", color: "#E89B5A", icon: "bulb" },
      { h: "ZEIT & AUFMERKSAMKEIT", t: "Gemeinsame Zeit ist das kostbarste Geschenk und stärkt die Bindung für ein Leben lang.", color: "#7A85C4", icon: "users" },
      { h: "FREIHEIT & VERANTWORTUNG", t: "Kinder brauchen Freiheit, um sich zu entfalten, und Verantwortung, um zu wachsen.", color: "#C77B7B", icon: "leaf" },
      { h: "VORBILD & INSPIRATION", t: "Kinder lernen durch Beobachtung. Wir sind ihr grösstes Vorbild — jeden Tag aufs Neue.", color: "#5A9B9B", icon: "globe" },
    ],
    bottomBanner:
      "ELTERNSCHAFT IST KEIN PERFEKTER WEG, ABER EIN GEMEINSAMER. MIT LIEBE, GEDULD UND VERTRAUEN BAUEN WIR DIE ZUKUNFT UNSERER KINDER.",
  },

  {
    num: 4,
    type: "content",
    kicker: "ELTERNSTIMME™",
    title: "DIE HERAUSFORDERUNGEN MODERNER FAMILIEN",
    quote:
      "Herausforderungen müssen uns nicht überwältigen — wenn wir sie gemeinsam meistern.",
    intro: [
      "Die Welt hat sich verändert — und mit ihr die Anforderungen an Eltern und Familien. Viele Familien stehen heute unter Druck wie nie zuvor.",
      { html: "Wir erkennen die Herausforderungen an, um <em>gemeinsam Lösungen zu finden</em> und Familien zu stärken." },
    ],
    cardsTitle: "WAS FAMILIEN HEUTE BESONDERS BELASTET:",
    cards: [
      { h: "ZEITDRUCK & STRESS", t: "Beruf, Haushalt, Termine und Verpflichtungen lassen oft wenig Zeit für das, was wirklich zählt — die Familie.", color: "#3D6BBF", icon: "clock-fast" },
      { h: "KONFLIKTE & KOMMUNIKATION", t: "Missverständnisse, unausgesprochene Gefühle und fehlende Gespräche führen zu Spannungen.", color: "#5A9B7E", icon: "speech" },
      { h: "DIGITALE WELT & ABLENKUNG", t: "Bildschirme, Soziale Medien und ständige Ablenkung nehmen Zeit und Aufmerksamkeit voneinander.", color: "#E89B5A", icon: "phone" },
      { h: "BERUF & FAMILIE VEREINBAREN", t: "Der Spagat zwischen Beruf und Familie fordert viel Energie und bringt viele Eltern an Grenzen.", color: "#7A85C4", icon: "balance" },
      { h: "TRENNUNG & PATCHWORK", t: "Trennung, Scheidung und neue Familienkonstellationen sind herausfordernd — besonders für Kinder.", color: "#C77B7B", icon: "heart-broken" },
      { h: "UNSICHERHEIT & ZUKUNFTSÄNGSTE", t: "Krisen, finanzielle Sorgen und Unsicherheiten in der Zukunft belasten Eltern und Kinder gleichermassen.", color: "#5A9B9B", icon: "cloud" },
    ],
    bottomBanner:
      "WIR NEHMEN DIESE HERAUSFORDERUNGEN ERNST — UND GEHEN SIE GEMEINSAM AN. FÜR STÄRKERE ELTERN. FÜR STÄRKERE KINDER. FÜR EINE BESSERE ZUKUNFT.",
  },

  {
    num: 5,
    type: "content",
    kicker: "ELTERNSTIMME™",
    title: "WAS KINDER VON IHREN ELTERN WIRKLICH BRAUCHEN",
    quote:
      "Kinder brauchen nicht mehr Dinge. Sie brauchen mehr von dem, was wirklich wichtig ist: uns.",
    intro: [
      "Kinder brauchen keine perfekten Eltern.",
      { html: "Sie brauchen <em>präsente</em>, <em>liebevolle</em> und <em>verlässliche</em> Eltern." },
      { html: "Sie brauchen <em>Verbindung</em> statt Bewertung." },
      "Wenn Kinder sich gesehen, gehört und verstanden fühlen, entwickeln sie Selbstvertrauen, Sicherheit und innere Stärke.",
    ],
    motto: "LIEBE. ZEIT. RESPEKT. GRENZEN. ORIENTIERUNG.",
    mottoSub: "Das sind die 5 Grundbedürfnisse jedes Kindes.",
    cardsTitle: "DIE 5 GRUNDBEDÜRFNISSE JEDES KINDES",
    numberedCards: [
      { n: 1, h: "LIEBE & VERBUNDENHEIT", t: "Kinder brauchen das Gefühl, bedingungslos geliebt zu werden — einfach so, wie sie sind.", color: "#3D6BBF", icon: "hug" },
      { n: 2, h: "ZEIT & AUFMERKSAMKEIT", t: "Gemeinsame Zeit ist das wertvollste Geschenk. Kinder brauchen unsere volle Präsenz.", color: "#5A9B7E", icon: "clock" },
      { n: 3, h: "RESPEKT & WERTSCHÄTZUNG", t: "Kinder brauchen Respekt für ihre Gefühle, Gedanken und ihre Persönlichkeit.", color: "#C77B7B", icon: "heart" },
      { n: 4, h: "GRENZEN & ORIENTIERUNG", t: "Klare, liebevolle Grenzen geben Sicherheit und helfen Kindern, sich in der Welt zurechtzufinden.", color: "#E89B5A", icon: "signpost" },
      { n: 5, h: "VERTRAUEN & ZUTRAUEN", t: "Kinder brauchen Vertrauen in sich selbst und das Zutrauen ihrer Eltern, es zu schaffen.", color: "#5A9B9B", icon: "mountain" },
    ],
    bottomBanner:
      "WENN WIR DIESEN 5 BEDÜRFNISSEN RAUM GEBEN, KÖNNEN KINDER AUFBLÜHEN — UND ZU STARKEN, LIEBEVOLLEN MENSCHEN WERDEN.",
  },

  {
    num: 6,
    type: "content",
    kicker: "DER SAT",
    title: "FAMILIENANSATZ",
    quote:
      "Familie ist kein Ort. Es ist ein Gefühl. Ein Team. Eine Entscheidung. Jeden Tag aufs Neue. Gemeinsam.",
    intro: [
      { html: "Der SAT Familienansatz basiert auf einem ganzheitlichen <strong>5-Säulen-Modell</strong>, das Eltern stärkt, Kinder schützt und Familien verbindet." },
      "Wir betrachten die Familie als ein lebendiges System, in dem jede Stimme zählt und jedes Herz wichtig ist.",
      { html: "<strong>Unser Ziel:</strong> starke Beziehungen, gesunde Entwicklung und eine gemeinsame Zukunft in <em>Liebe</em>, <em>Respekt</em> und <em>Vertrauen</em>." },
    ],
    cardsTitle: "DIE 5 SÄULEN DES SAT FAMILIENANSATZES",
    numberedCards: [
      { n: 1, h: "BEZIEHUNG STÄRKEN", t: "Wir fördern eine liebevolle, respektvolle und verbindende Beziehung zwischen Eltern und Kindern.", color: "#3D6BBF", icon: "hug" },
      { n: 2, h: "KOMMUNIKATION VERBESSERN", t: "Wir helfen Familien, offen, ehrlich und wertschätzend miteinander zu sprechen und zuzuhören.", color: "#5A9B7E", icon: "speech" },
      { n: 3, h: "KONFLIKTE LÖSEN", t: "Wir begleiten Familien dabei, Konflikte konstruktiv zu lösen und als Chance für Wachstum zu nutzen.", color: "#E89B5A", icon: "puzzle" },
      { n: 4, h: "KINDER STÄRKEN", t: "Wir unterstützen Kinder in ihrer emotionalen, mentalen und sozialen Entwicklung — für ein starkes Selbst.", color: "#7A5DC4", icon: "heart" },
      { n: 5, h: "ZUKUNFT GESTALTEN", t: "Wir geben Familien Werkzeuge, Werte und Visionen an die Hand, um gemeinsam eine bessere Zukunft zu erschaffen.", color: "#5A9B9B", icon: "users" },
    ],
    bottomBanner:
      "WIR ARBEITEN NICHT AN PROBLEMEN. WIR ARBEITEN AN BEZIEHUNGEN. AN MENSCHEN. AN ZUKUNFT.",
  },

  {
    num: 7,
    type: "content",
    kicker: "UNSERE",
    title: "ANGEBOTE",
    quote: "Wir stärken, was wirklich zählt: Beziehungen. Vertrauen. Zusammenhalt.",
    intro: [
      "Wir begleiten Eltern, Kinder und Familien auf ihrem Weg zu mehr Verbindung, Verständnis und Vertrauen.",
      "Unsere Angebote sind praxisnah, lösungsorientiert und mit Herz entwickelt — für den Alltag und fürs Leben.",
    ],
    motto: "FÜR STARKE ELTERN. FÜR STABILE KINDER. FÜR STARKE FAMILIEN.",
    cardsTitle: "WIR BIETEN IHNEN GANZHEITLICHE LÖSUNGEN:",
    numberedCards: [
      { n: 1, h: "ELTERNCOACHING", t: "Individuelle Begleitung für Eltern, die ihre Kommunikation verbessern, Konflikte lösen und ihre Elternschaft stärken möchten.", color: "#3D6BBF", icon: "users" },
      { n: 2, h: "PAAR- & FAMILIENBERATUNG", t: "Gemeinsam Lösungen finden, Beziehungen heilen und eine neue Basis von Respekt und Vertrauen schaffen.", color: "#5A9B7E", icon: "high-five" },
      { n: 3, h: "KINDERCOACHING", t: "Kinder stärken, ihr Selbstvertrauen aufbauen und emotionale Kompetenzen für ein glückliches Leben entwickeln.", color: "#E89B5A", icon: "hand-heart" },
      { n: 4, h: "WORKSHOPS & SEMINARE", t: "Praxisnahe Workshops für Eltern, Paare und Kinder — für mehr Wissen, Inspiration und konkrete Werkzeuge im Alltag.", color: "#7A5DC4", icon: "speech-group" },
      { n: 5, h: "ONLINE-PROGRAMME & KURSE", t: "Flexibel von überall aus lernen und wachsen — mit unseren Online-Kursen für Eltern, Kinder und die ganze Familie.", color: "#C77B7B", icon: "laptop" },
      { n: 6, h: "VORTRÄGE & INSPIRATION", t: "Inspirierende Vorträge und Events, die berühren, motivieren und neue Perspektiven für Familien eröffnen.", color: "#5A9B9B", icon: "hand-heart" },
    ],
    bottomBanner:
      "JEDES ANGEBOT HAT EIN ZIEL: MEHR VERBINDUNG. MEHR VERSTÄNDNIS. MEHR VERTRAUEN. MEHR LIEBE. MEHR ZUSAMMENHALT.",
  },

  {
    num: 8,
    type: "content",
    kicker: "UNSERE",
    title: "METHODEN",
    quote:
      "Die beste Methode ist die, die Menschen in ihre Kraft bringt und Familien verbindet. Jeden Tag ein Stück.",
    intro: [
      "Unsere Methoden basieren auf wissenschaftlich fundierten Ansätzen, langjähriger Erfahrung und der tiefen Überzeugung, dass Veränderung von innen nach aussen beginnt.",
      { html: "Wir verbinden <strong>Herz und Verstand</strong>, Struktur und Intuition, Einzelarbeit und Gemeinschaft — für nachhaltige Veränderung auf allen Ebenen." },
    ],
    motto: "PRAXISNAH. GANZHEITLICH. TRANSFORMIEREND.",
    cardsTitle: "UNSERE BEWÄHRTEN METHODEN FÜR STARKE FAMILIEN",
    numberedCards: [
      { n: 1, h: "SYSTEMISCHE FAMILIENARBEIT", t: "Wir betrachten die Familie als System und fördern Verständnis, Klarheit und neue Lösungswege.", color: "#3D6BBF", icon: "users" },
      { n: 2, h: "KOMMUNIKATION & DIALOGMETHODEN", t: "Wir stärken die Gesprächskultur in Familien — achtsam, wertschätzend und auf Augenhöhe.", color: "#5A9B7E", icon: "speech" },
      { n: 3, h: "EMOTIONALE INTELLIGENZ & HERZARBEIT", t: "Wir helfen, Gefühle zu erkennen, zu verstehen und konstruktiv auszudrücken — für mehr Nähe und Verbindung.", color: "#E89B5A", icon: "heart" },
      { n: 4, h: "KONFLIKTLÖSUNG & MEDIATION", t: "Wir begleiten Familien, Konflikte fair, respektvoll und nachhaltig zu lösen — ohne Gewinner und Verlierer.", color: "#7A5DC4", icon: "puzzle" },
      { n: 5, h: "ZIELARBEIT & VISIONSENTWICKLUNG", t: "Wir entwickeln gemeinsam klare Ziele und eine gemeinsame Vision für die Familie und die Zukunft.", color: "#C77B7B", icon: "target" },
      { n: 6, h: "STÄRKENORIENTIERUNG & RESSOURCENARBEIT", t: "Wir aktivieren die Stärken jedes Einzelnen und nutzen Ressourcen für mehr Leichtigkeit im Familienleben.", color: "#5A9B9B", icon: "meditate" },
    ],
    bottomBanner:
      "WIR NUTZEN BEWÄHRTE METHODEN — ABER JEDES FAMILIENSYSTEM IST EINZIGARTIG. DESHALB ARBEITEN WIR INDIVIDUELL, FLEXIBEL UND HERZORIENTIERT.",
  },

  {
    num: 9,
    type: "content",
    kicker: "DIE WERTE",
    titleLines: ["EINER STARKEN", "FAMILIE"],
    title: "FAMILIE",
    quote: "Werte sind wie Wurzeln. Was wir heute leben, trägt unsere Kinder morgen.",
    quoteVariant: "light",
    intro: [
      "Werte sind das unsichtbare Fundament, auf dem Vertrauen wächst, Beziehungen heilen und Kinder zu starken, liebevollen Menschen werden.",
    ],
    motto: "WIR LEBEN DIE WERTE — UND GEBEN SIE WEITER.",
    cardsTitle: "UNSERE 8 KERNWERTE",
    eightCards: [
      { h: "LIEBE", t: "Wir lieben bedingungslos und zeigen es jeden Tag — in Worten, Taten und Blicken.", color: "#3D6BBF", icon: "heart", solid: true },
      { h: "RESPEKT", t: "Wir begegnen einander mit Achtung, Wertschätzung und offenem Herzen.", color: "#5A9B7E", icon: "high-five", solid: true },
      { h: "VERTRAUEN", t: "Wir schaffen Sicherheit durch Ehrlichkeit, Verlässlichkeit und Offenheit.", color: "#E89B5A", icon: "shield", solid: true },
      { h: "ZUSAMMENHALT", t: "Wir stehen füreinander ein, unterstützen uns und gehen gemeinsam durchs Leben.", color: "#E76A8E", icon: "users", solid: true },
      { h: "WACHSTUM", t: "Wir fördern Entwicklung, lernen voneinander und feiern Fortschritte — kleine wie grosse.", color: "#3D6BBF", icon: "leaf", solid: true },
      { h: "INTEGRITÄT", t: "Wir leben, was wir lehren, und handeln im Einklang mit unseren Werten und Überzeugungen.", color: "#5A9B7E", icon: "star", solid: true },
      { h: "VERANTWORTUNG", t: "Wir übernehmen Verantwortung für uns, unsere Worte, unser Handeln und unsere Familie.", color: "#E89B5A", icon: "compass", solid: true },
      { h: "DANKBARKEIT", t: "Wir schätzen das, was wir haben, und sehen jeden Tag als ein Geschenk.", color: "#C77BAB", icon: "candle", solid: true },
    ],
    bottomBanner:
      "WENN WERTE IN EINER FAMILIE LEBEN, WIRD DAS ZU EINEM LEUCHTENDEN VERMÄCHTNIS — FÜR HEUTE, MORGEN UND FÜR GENERATIONEN.",
    bottomBannerVariant: "cream",
  },

  {
    num: 10,
    type: "content",
    layout: "duoPanels",
    kicker: "DIE ZUKUNFT",
    title: "GESTALTEN",
    quote:
      "Wir hinterlassen unseren Kindern nicht nur ein Erbe — sondern die Kraft, es weiterzuführen und die Welt ein Stück besser zu machen.",
    intro: [
      { html: "Die Zukunft entsteht nicht einfach — wir gestalten sie <em>gemeinsam</em>." },
      { html: "Indem wir heute in Beziehungen investieren, Werte leben und unsere Kinder stärken, bauen wir eine Welt auf, in der <em>Liebe</em>, <em>Respekt</em> und <em>Vertrauen</em> die Basis sind." },
    ],
    motto: "FÜR UNSERE KINDER. FÜR UNSERE FAMILIEN. FÜR HEUTE. FÜR MORGEN. FÜR GENERATIONEN.",
    duoPanels: [
      {
        title: "UNSER AUFTRAG",
        variant: "light-color",
        items: [
          { color: "#3D6BBF", icon: "users", text: "Wir <b>stärken</b> Familien als Fundament einer gesunden Gesellschaft." },
          { color: "#5A9B7E", icon: "hand-heart", text: "Wir <b>begleiten</b> Menschen auf ihrem Weg zu mehr Verbindung, Verständnis und Vertrauen." },
          { color: "#7A5DC4", icon: "globe", text: "Wir <b>schaffen</b> Impulse für eine Zukunft, die von Menschlichkeit und Bewusstsein geprägt ist." },
        ],
      },
      {
        title: "UNSER VERSPRECHEN",
        variant: "light-color",
        items: [
          { color: "#E89B5A", icon: "heart", text: "Wir arbeiten mit <b>Herz</b>, wissenschaftlich fundiert, praxisnah und ganzheitlich." },
          { color: "#5A9B7E", icon: "shield", text: "Wir begegnen jedem Menschen mit <b>Respekt</b>, Wertschätzung und <b>Integrität</b>." },
          { color: "#3D6BBF", icon: "star", text: "Wir geben <b>Wissen</b>, <b>Werkzeuge</b> und <b>Inspiration</b>, die im Alltag wirken und nachhaltig verändern." },
        ],
      },
    ],
    bottomBanner:
      "LASS UNS GEMEINSAM DIE ZUKUNFT GESTALTEN — FÜR STABILE FAMILIEN. FÜR STÄRKERE KINDER. FÜR EINE BESSERE WELT.",
    bottomBannerVariant: "cream",
  },

  {
    num: 11,
    type: "content",
    layout: "valuesLegacy",
    kicker: "DEINE WERTE.",
    title: "DEIN VERMÄCHTNIS.",
    quote: "Was wir heute vorleben, wird morgen ihre Stärke sein. Unsere Werte sind ihr Kompass.",
    intro: [
      "Werte sind wie Wurzeln — sie geben Halt, Richtung und Kraft. Sie prägen, wie wir leben, lieben, handeln und Entscheidungen treffen.",
      { html: "Wenn wir unsere Werte kennen und leben, schenken wir unseren Kindern mehr als Worte: Wir hinterlassen <strong>ein Vermächtnis</strong>, das <em>Generationen trägt</em> und <em>inspiriert</em>." },
    ],
    cardsTitle: "8 WERTE, DIE GENERATIONEN STÄRKEN",
    eightCards: [
      { h: "LIEBE", t: "Wir lieben bedingungslos und zeigen es in Worten, Taten und Blicken.", color: "#3D6BBF", icon: "heart" },
      { h: "RESPEKT", t: "Wir begegnen einander mit Achtung, Wertschätzung und offenem Herzen.", color: "#5A9B7E", icon: "high-five" },
      { h: "VERTRAUEN", t: "Wir schaffen Sicherheit durch Ehrlichkeit, Verlässlichkeit und Offenheit.", color: "#E89B5A", icon: "shield" },
      { h: "ZUSAMMENHALT", t: "Wir stehen füreinander ein, unterstützen uns und gehen gemeinsam durchs Leben.", color: "#A67ED1", icon: "users" },
      { h: "WACHSTUM", t: "Wir fördern Entwicklung, lernen voneinander und feiern Fortschritte — kleine wie grosse.", color: "#C77B7B", icon: "leaf" },
      { h: "INTEGRITÄT", t: "Wir leben, was wir lehren, und handeln im Einklang mit unseren Werten.", color: "#5AB0B0", icon: "star" },
      { h: "VERANTWORTUNG", t: "Wir übernehmen Verantwortung für uns, unsere Worte, unser Handeln und unsere Familie.", color: "#D4AF37", icon: "compass" },
      { h: "DANKBARKEIT", t: "Wir schätzen das, was wir haben, und sehen jeden Tag als ein Geschenk.", color: "#5A9B7E", icon: "candle" },
    ],
    legacyPanels: [
      {
        kind: "cream", title: "UNSER VERMÄCHTNIS",
        text: "Wir wollen eine Welt hinterlassen, in der unsere Kinder stark, frei und herzlich leben können.",
        footer: "UNSERE WERTE SIND DAS FUNDAMENT. UNSER VERMÄCHTNIS IST DIE ZUKUNFT.",
        icon: "tree",
      },
      {
        kind: "white", title: "SO GEBEN WIR WERTE WEITER",
        list: [
          "Wir leben Werte jeden Tag vor.",
          "Wir sprechen über Werte und ihre Bedeutung.",
          "Wir ermutigen unsere Kinder, ihre Werte zu entdecken und zu leben.",
          "Wir schaffen Rituale und Erinnerungen, die Werte erlebbar machen.",
          "Wir feiern, wenn Werte gelebt werden.",
        ],
      },
      {
        kind: "softblue",
        text: "Unsere Werte sind das Geschenk, das bleibt.",
        emphasis: "Unser Vermächtnis ist die Liebe, die weiterlebt.",
        icon: "family",
      },
    ],
    bottomBanner:
      "WIR SIND NICHT PERFEKT — ABER WIR SIND BEWUSST. WIR LEBEN WERTE. WIR SCHENKEN ZUKUNFT. WIR HINTERLASSEN SPUREN.",
  },

  {
    num: 12,
    type: "content",
    layout: "legacy",
    kicker: "UNSER ERBE.",
    title: "UNSERE SPUR.",
    quote: "Unsere Kinder sind nicht unsere Zukunft. Sie sind unsere Fortsetzung in Liebe.",
    quoteVariant: "light",
    intro: [
      { html: "Das, was wir heute leben, prägt das, was morgen bleibt. Unser Erbe ist nicht das, was wir <em>besitzen</em>, sondern das, was wir <em>weitergeben</em>: <strong>Werte. Liebe. Wissen. Inspiration.</strong>" },
      "Wir hinterlassen keine Dinge — wir hinterlassen Menschlichkeit.",
    ],
    cardsTitle: "WAS WIR UNSEREN KINDERN MITGEBEN",
    cards: [
      { h: "WERTSCHÄTZUNG", t: "Wir zeigen ihnen, dass sie wichtig sind — einfach weil sie sind.", color: "#3D6BBF", icon: "heart" },
      { h: "VERTRAUEN", t: "Wir glauben an sie und geben ihnen den Raum, sie selbst zu werden.", color: "#5A9B7E", icon: "leaf" },
      { h: "INSPIRATION", t: "Wir teilen unser Wissen, unsere Erfahrungen und unsere Visionen.", color: "#E89B5A", icon: "bulb" },
      { h: "LIEBE", t: "Wir lieben bedingungslos und zeigen es in Worten, Taten und Blicken.", color: "#C77B7B", icon: "hand-heart" },
      { h: "ZUSAMMENHALT", t: "Wir stehen füreinander ein und gehen gemeinsam durchs Leben.", color: "#5AB0B0", icon: "users" },
      { h: "INTEGRITÄT", t: "Wir leben vor, was wir lehren — mit Herz, Verstand und Haltung.", color: "#A67ED1", icon: "star" },
    ],
    legacyPanels: [
      {
        kind: "cream",
        title: "WIR HINTERLASSEN SPUREN.",
        text: "Nicht durch Perfektion, sondern durch Präsenz. Nicht durch Macht, sondern durch Menschlichkeit. Nicht durch Worte, sondern durch unser Leben.",
        footer: "DAS IST UNSER ERBE. DAS IST UNSERE SPUR.",
        icon: "handprints",
      },
      {
        kind: "white",
        title: "FRAGEN, DIE UNS LEITEN",
        list: [
          "Welche Werte sollen unsere Kinder in die Welt tragen?",
          "Welches Wissen möchten wir weitergeben?",
          "Wie wollen wir in Erinnerung bleiben?",
          "Welche Welt wollen wir gemeinsam erschaffen?",
          "Was ist unsere einzigartige Spur?",
        ],
      },
      {
        kind: "rose",
        text: "Unser Erbe beginnt nicht irgendwann.",
        emphasis: "Es beginnt jetzt.",
        icon: "fingerheart",
      },
    ],
    bottomBanner:
      "WIR GESTALTEN HEUTE, WAS MORGEN ZÄHLT. FÜR UNSERE KINDER. FÜR UNSERE FAMILIEN. FÜR DIE WELT.",
    bottomBannerVariant: "cream",
  },

  {
    num: 13,
    type: "content",
    layout: "promises",
    kicker: "UNSERE",
    title: "VERSPRECHEN.",
    quote:
      "Wir begleiten euch nicht nur ein Stück — wir gehen ein Stück eures Weges mit. Mit Herz, Klarheit und Verbindung.",
    intro: [
      "Wir stehen an eurer Seite — mit Erfahrung, Herz und einem klaren Methodenkompass. Wir unterstützen euch dabei, eure Stärken zu entfalten, Herausforderungen zu meistern und ein erfülltes, verbundenes Familienleben zu gestalten.",
    ],
    motto: "IHR SEID NICHT ALLEIN. WIR SIND FÜR EUCH DA.",
    cardsTitle: "WAS IHR VON UNS ERWARTEN KÖNNT",
    cards: [
      { h: "GANZHEITLICHE BEGLEITUNG", t: "Wir betrachten euch als Ganzes — mit Herz, Verstand und Seele. Euer Wachstum steht im Mittelpunkt.", color: "#3D6BBF", icon: "hand-heart" },
      { h: "KLARHEIT & ORIENTIERUNG", t: "Wir schaffen Klarheit in herausfordernden Situationen und zeigen neue Wege und Perspektiven auf.", color: "#5A9B7E", icon: "compass" },
      { h: "INDIVIDUELLE METHODEN", t: "Unsere Methoden sind wissenschaftlich fundiert, praxisnah und werden individuell auf euch abgestimmt.", color: "#E89B5A", icon: "users" },
      { h: "HERZ & VERBINDUNG", t: "Wir stärken eure Beziehungen und fördern ein Miteinander, das von Liebe und Respekt getragen ist.", color: "#C77B7B", icon: "heart" },
      { h: "NACHHALTIGE VERÄNDERUNG", t: "Wir geben euch Werkzeuge an die Hand, die langfristig wirken — für heute, morgen und kommende Generationen.", color: "#5AB0B0", icon: "trending" },
      { h: "SICHERER RAHMEN", t: "Ihr findet bei uns einen geschützten Raum, in dem Vertrauen, Vertraulichkeit und Wertschätzung zählen.", color: "#A67ED1", icon: "shield" },
    ],
    legacyPanels: [
      {
        kind: "cream",
        title: "UNSER GEMEINSAMES ZIEL:",
        text: "Starke Familien. Starke Kinder.",
        emphasis: "Eine bessere Welt — heute und für Generationen.",
        icon: "users-glow",
      },
      {
        kind: "white",
        list: [
          "Wir glauben an euch.",
          "Wir glauben an eure Kinder.",
          "Wir glauben an eure Zukunft.",
        ],
      },
      {
        kind: "cream",
        text: "Lasst uns gemeinsam euren Weg gestalten.",
        emphasis: "Wir freuen uns auf euch!",
        icon: "fingerheart-green",
      },
    ],
    bottomBanner:
      "WIR HALTEN, WAS WIR VERSPRECHEN: PERSÖNLICH. | KOMPETENT. | WERTSCHÄTZEND. | VERLÄSSLICH. | INSPIRIEREND.",
    bottomBannerVariant: "cream",
  },

  {
    num: 14,
    type: "content",
    layout: "voice",
    kicker: "UNSERE STIMME.",
    title: "UNSER EINFLUSS.",
    quote: "Die beste Art, die Zukunft vorauszusagen, ist, sie gemeinsam zu gestalten.",
    quoteVariant: "light",
    intro: [
      "Wir nutzen unsere Stimme — nicht nur für uns, sondern für andere. Wir stehen ein für Werte, die zählen. Wir engagieren uns für eine bessere Welt — im Kleinen wie im Grossen.",
    ],
    motto: "UNSERE STIMME KANN VERÄNDERN. UNSER EINFLUSS KANN BEWEGEN.",
    cardsTitle: "WIE WIR UNSERE STIMME NUTZEN",
    cards: [
      { h: "WORTE, DIE BEWEGEN", t: "Wir sprechen aus, was wichtig ist — mit Respekt, Klarheit und Mut.", color: "#3D6BBF", icon: "lightning" },
      { h: "EINFLUSS, DER DIENT", t: "Wir setzen unseren Einfluss ein, um Gutes zu bewirken — nicht, um Macht auszuüben.", color: "#5A9B7E", icon: "hand-heart" },
      { h: "GEMEINSCHAFT STÄRKEN", t: "Wir verbinden uns mit Gleichgesinnten und schaffen positive Netzwerke.", color: "#E89B5A", icon: "users" },
      { h: "FÜR ANDERE EINSTEHEN", t: "Wir setzen uns ein für Gerechtigkeit, Mitgefühl und Menschenwürde.", color: "#C77B7B", icon: "hand-heart" },
      { h: "LOKAL HANDELN, GLOBAL DENKEN", t: "Wir übernehmen Verantwortung in unserem Umfeld — und denken an die Welt.", color: "#5AB0B0", icon: "globe" },
      { h: "ZUKUNFT MITGESTALTEN", t: "Wir bringen Ideen ein, packen mit an und gestalten die Welt, die wir wollen.", color: "#A67ED1", icon: "leaf" },
    ],
    legacyPanels: [
      {
        kind: "cream",
        title: "SO GESTALTEN WIR UNSEREN EINFLUSS",
        list: [
          "Wir hören zu, bevor wir sprechen.",
          "Wir informieren uns und bilden uns eine eigene Meinung.",
          "Wir handeln verantwortungsbewusst — online und offline.",
          "Wir unterstützen Projekte und Menschen, die Gutes tun.",
          "Wir inspirieren andere durch unser Beispiel.",
        ],
        icon: "tree",
      },
      {
        kind: "cream",
        title: "UNSERE STIMME. UNSER EINFLUSS.",
        text: "Kleine Stimmen. Grosse Wirkung. Viele Menschen. Eine Bewegung.",
        emphasis: "Gemeinsam können wir die Welt zum Besseren verändern.",
        icon: "heart-glow",
      },
    ],
    bottomBanner:
      "WIR HEBEN UNSERE STIMME. WIR NUTZEN UNSEREN EINFLUSS. FÜR UNSERE WERTE. FÜR UNSERE KINDER. FÜR UNSERE WELT.",
  },

  {
    num: 15,
    type: "content",
    layout: "promises",
    kicker: "GEMEINSAM HEUTE.",
    title: "FÜR MORGEN.",
    quote:
      "Die Zukunft gehört nicht denen, die auf sie warten, sondern denen, die sie aktiv gestalten — gemeinsam.",
    quoteVariant: "light",
    intro: [
      "Unsere Reise beginnt jetzt — in unserem Zuhause, in unserer Familie, in unserer Gemeinschaft.",
      { html: "Wenn wir unsere Werte leben, unsere Stimmen nutzen und unsere Kräfte bündeln, gestalten wir eine Zukunft, die von <em>Liebe</em>, <em>Respekt</em> und <em>Vertrauen</em> getragen ist." },
    ],
    motto: "WIR SIND DIE GENERATION, DIE VERÄNDERUNG MÖGLICH MACHT. FÜR UNSERE KINDER. FÜR UNSERE FAMILIEN. FÜR DIE WELT.",
    cardsTitle: "WAS WIR GEMEINSAM ERSCHAFFEN",
    cards: [
      { h: "STARKE FAMILIEN", t: "Wir schaffen Räume der Liebe, des Vertrauens und des Miteinanders — die Basis für ein erfülltes Leben.", color: "#3D6BBF", icon: "users" },
      { h: "BESSERE WELT", t: "Wir handeln verantwortungsvoll und bewusst — für eine Welt, in der Mensch und Natur im Einklang leben.", color: "#5A9B7E", icon: "globe" },
      { h: "INSPIRIERENDE ZUKUNFT", t: "Wir geben Wissen, Erfahrungen und Werte weiter — und inspirieren die nächsten Generationen.", color: "#E89B5A", icon: "bulb" },
      { h: "KULTUR DES HERZENS", t: "Wir fördern Empathie, Respekt und Menschlichkeit und schaffen eine Kultur, in der jeder zählt.", color: "#C77B7B", icon: "hand-heart" },
      { h: "SINNSTIFTENDES LEBEN", t: "Wir leben mit Sinn, Klarheit und Leidenschaft — und tragen so zu einer positiven Veränderung bei.", color: "#5AB0B0", icon: "trending" },
      { h: "NACHHALTIGES ERBE", t: "Wir hinterlassen Spuren, die bleiben — in unseren Kindern, in unseren Gemeinschaften und in der Welt.", color: "#A67ED1", icon: "star" },
    ],
    legacyPanels: [
      {
        kind: "cream",
        title: "WIR SIND MEHR ALS EINZELNE.",
        text: "Wir sind Familien. Wir sind Gemeinschaft. Wir sind die Veränderung.",
        footer: "LASST UNS GEMEINSAM HANDELN. FÜR HEUTE. FÜR MORGEN. FÜR IMMER.",
        icon: "tree",
      },
      {
        kind: "cream",
        title: "DANKE, DASS IHR TEIL DIESER REISE SEID.",
        text: "Lasst uns Hand in Hand gehen — mit Herz, Verstand und Seele.",
        emphasis: "FÜR UNSERE KINDER. FÜR UNSERE WELT.",
        icon: "heart-glow",
      },
    ],
    bottomBanner:
      "DAS IST UNSER VERSPRECHEN. DAS IST UNSER WEG. GEMEINSAM HEUTE. FÜR MORGEN. FÜR GENERATIONEN. FÜR DIE WELT.",
  },

  {
    num: 16,
    type: "finalCTA",
    kicker: "GEMEINSAM.",
    title: "DIE ZUKUNFT GESTALTEN.",
    subtitle: "Für unsere Kinder. Für unsere Familien. Für die Welt.",
    quote: "Die Zukunft gehört nicht denen, die auf sie warten, sondern denen, die sie gestalten.",
    intro: [
      "Liebe beginnt bei uns — und wächst weiter.",
      "Lasst uns heute den ersten Schritt machen.",
    ],
    emphasis: "Jeder kleine Schritt zählt.",
    heartIcons: [
      { label: "VERSTEHEN", icon: "users", color: "#3D6BBF" },
      { label: "WERTSCHÄTZEN", icon: "hand-heart", color: "#5A9B7E" },
      { label: "HANDELN", icon: "compass", color: "#E89B5A" },
      { label: "WACHSEN", icon: "tree", color: "#C77B7B" },
      { label: "VERÄNDERN", icon: "globe", color: "#D4AF37" },
    ],
    actionsTitle: "WAS KANNST DU HEUTE TUN?",
    actions: [
      { label: "Beginne mit einem Gespräch.", icon: "speech", color: "#3D6BBF" },
      { label: "Stelle dir wichtige Fragen.", icon: "bulb", color: "#5A9B7E" },
      { label: "Setze einen kleinen, konkreten Schritt.", icon: "compass", color: "#E89B5A" },
      { label: "Teile dein Wissen & deine Liebe.", icon: "heart", color: "#C77B7B" },
      { label: "Sei ein Vorbild für deine Kinder.", icon: "users", color: "#A67ED1" },
    ],
    movementBox: {
      title: "WERDE TEIL DER HERZBEWEGUNG",
      sub: "Gemeinsam können wir etwas Grosses bewegen!",
      cta: "Zur Herzbewegung →",
      to: "/herzbewegung",
    },
    closing: "Love Is Transformation",
    closingSub: "Die SAT-Akademie — für eine bessere Welt",
  },
];

export default elternstimmeSlides;
